import UploadCASUsecase from "@domains/salesFeatures/Advisory/useCases/UploadCASUsecase";
import CASUploadHistoryUseCase from "@domains/salesFeatures/Advisory/useCases/CASUploadHistoryUseCase";
import CASUploadSummaryUseCase from "@domains/salesFeatures/Advisory/useCases/CASUploadSummaryUseCase";
import SyncNuvamaPortfolioUseCase from "@domains/salesFeatures/Advisory/useCases/SyncNuvamaPortfolioUseCase";
export default (function (repo) {
    return {
        advisory: {
            uploadCAS: new UploadCASUsecase(repo.advisory),
            getCASUploadHistory: new CASUploadHistoryUseCase(repo.advisory),
            getCASUploadSummary: new CASUploadSummaryUseCase(repo.advisory),
            syncNuvamaPortfolio: new SyncNuvamaPortfolioUseCase(repo.advisory)
        },
    };
});
